import axios from 'axios';
import encodeQueryParams from '../helpers/encodeQueryData';

class EnrolleeService {

  /*
  // Пример того, как будет выглядеть объект queryParams (специально для json-server):
  const queryParams = {
    _page: 0,
    _limit: 10,
    fullName_like: 'Sample Text'
  };
  */

  async getEnrolless(queryParams) {
    return await axios.get(`http://localhost:3000/enrollees?${encodeQueryParams(queryParams)}`);
  }

  async getEnrolleeById(id) {
    return await axios.get(`http://localhost:3000/enrollees/${id}`);
  }

}

export default EnrolleeService;